import React from "react";
import { Spin, Modal, Row, Col } from "antd";
import classNames from "classnames";
import isEmpty from "lodash/isEmpty";
import WeaLocaleProvider from "../../wea-locale-provider";
import WeaLeftRightLayout from "../../wea-left-right-layout";
import WeaLeftTree from "../../wea-left-tree";

const { getLabel } = WeaLocaleProvider;

// 通过ref调用，设置数据
export function set(datas) {
  const { isSingle } = this.props;
  if (isSingle) {
    let id = "";
    let name = "";
    let data = [];
    if (!isEmpty(datas)) {
      name = datas[0].name;
      id = datas[0].id;
      let tmp = { ...datas[0], id, name };
      if (this.isCrm()) {
        tmp.type = "resource";
      }
      data.push(tmp);
    }
    this.setState({ idCache: id, nameCache: name, data });
  } else {
    let selectedData = [];
    if (this.isCrm()) {
      selectedData = this.replaceSearchValues(datas);
    } else {
      datas.forEach(item => {
        if (item) {
          item.name =
            item.orgWholePathspan || item[inputName] || item.name || "";
          selectedData.push(item);
        }
      });
    }
    this.setState({ selectedData, data: selectedData });
  }
}
// 通过ref调用，获取数据
export function get() {
  const { isSingle } = this.props;
  const { idCache, nameCache } = this.state;
  if (isSingle) {
    return {
      id: idCache,
      name: nameCache
    };
  } else {
    const { selectedData, inputId } = this.state;
    let values = [];
    !isEmpty(selectedData) &&
      selectedData.forEach(d => {
        values.push(d[inputId] || d.id);
      });
    return {
      id: values,
      datas: selectedData
    };
  }
}

// 关闭modal框
export function closeModal() {
  this.setState({ visible: false });
}

// 打开modal框
export function openModal() {
  this.onCustomClick();
}

export function reload() {
  console.log("reload: ");
}

// 左侧树onSelect事件
export function onLeftTreeSelect(key, count, countType) {
  const {
    leftToSearchKey,
    form: { setFieldsValue }
  } = this.props;
  if (leftToSearchKey) {
    const param = { [leftToSearchKey]: key };
    this.onSearch(param);
    const valueSpan = countType.node.props.data.name;
    const valueObj = [
      {
        id: key,
        name: valueSpan
      }
    ];
    setFieldsValue(param, valueSpan, valueObj);
    this.setState({
      leftSelectKeys: [key],
      showSearchAd: false
    });
  }
}

// 获取modal框
export function getModal() {
  const { visible, modalloaded } = this.state;
  let modalProps = { visible };
  if (modalloaded || (!modalloaded && visible)) {
    const {
      showTop,
      iconBgcolor,
      iconFontColor,
      title = getLabel(24986, "标题"),
      zIndex,
      modalStyle: { width },
      browserModalProps,
      icon,
      hasLeftTree,
      isMultCheckbox
    } = this.props;
    const {
      dataIcon,
      dataIconBgColor,
      dataIconFontColor,
      loading,
      leftTreeDatas,
      leftExpandKeys,
      leftSelectKeys
    } = this.state;
    const isSingle = this.props.isSingle || isMultCheckbox;
    const wrapClassName = classNames(
      "wea-browser-modal",
      `wea-browser-${isSingle ? "single" : "muli"}`,
      `wea-browser-test-${isSingle ? "single" : "muli"}`,
      {
        "wea-browser-table-cursor": isSingle,
        "wea-hr-muti-input": !isSingle,
        "no-top": isSingle && !showTop
      }
    );
    let iconEle = (
      <span style={{ verticalAlign: "middle", marginRight: 10 }}>
        <i className={icon} />
      </span>
    );
    if (dataIconBgColor || iconBgcolor) {
      iconEle = (
        <div
          className="wea-browser-single-icon-circle"
          style={{
            background: dataIconBgColor || iconBgcolor,
            color: dataIconFontColor || iconFontColor
          }}
        >
          <i className={dataIcon || icon} />
        </div>
      );
    }
    const titleEle = (
      <Row>
        <Col span="22" style={{ paddingLeft: 20, lineHeight: "48px" }}>
          <div className="wea-browser-single-title">
            {iconEle}
            <span style={{ verticalAlign: "middle" }}>{title}</span>
          </div>
        </Col>
      </Row>
    );
    let content = this.getModalMainContent();
    // if (isSingle && !hasLeftTree) {
    //   content = (
    //     <div style={window.setDialogFullWindow ? {} : { minHeight: 423 }}>
    //       {content}
    //     </div>
    //   );
    // }
    let modalChild = [
      this.getActionBar(),
      <Spin spinning={loading}>{content}</Spin>
    ];
    if (hasLeftTree) {
      modalChild = [
        <div
          style={window.setDialogFullWindow ? {} : { height: 423 + 35 + 46 }}
          // style={
          //   window.setDialogFullWindow
          //     ? {}
          //     : { height: this.getContentHeight() + 46 }
          // }
        >
          <WeaLeftRightLayout
            leftCom={
              <WeaLeftTree
                datas={leftTreeDatas}
                selectedKeys={leftSelectKeys}
                expandedKeys={leftExpandKeys}
                itemMainKey="key"
                onExpand={(keys, target) => {
                  if (target.node.childs) {
                    this.setState({ leftExpandKeys: keys });
                  } else {
                    this.getLeftTreeDatas(
                      { id: target.node.key },
                      target.node,
                      () => {
                        // 控制节点展开状态
                        this.setState({ leftExpandKeys: keys });
                      }
                    );
                  }
                }}
                onSelect={this.onLeftTreeSelect}
              />
            }
          >
            {this.getActionBar()}
            <Spin spinning={loading}>{content}</Spin>
          </WeaLeftRightLayout>
        </div>
      ];
    }
    modalProps = {
      ...modalProps,
      zIndex,
      width,
      wrapClassName: hasLeftTree
        ? `${wrapClassName ? wrapClassName : ""} wea-browser-withLeftTreeModal`
        : wrapClassName,
      title: titleEle,
      maskClosable: false,
      onCancel: this.handleCancel,
      footer: this.getModalFooter(),
      ...browserModalProps,
      children: modalChild
    };
  }
  return (
    <Modal
      ref={el => {
        if (!el && this.state.modalloaded) {
          this.setState({ modalloaded: false });
        }
        if (el && !this.modal) {
          this.modal = el;
          this.setState({ modalloaded: true });
        }
      }}
      {...modalProps}
    />
  );
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/browser/getModal.js